import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  formContainer: {
    padding: '10px',
    margin: '10px 0',
    borderRadius: '8px',
    background: theme.palette.primary.light,
  },
}));

export default useStyles;
